import { all, takeLatest } from 'redux-saga/effects';

import {
    INIT_AZURE_AUTH,
    LOGIN_REQUEST,
    LOGOUT_REQUEST,
    TWO_FA_LOGIN_REQUEST,
    LOGIN_VIA_AZURE,
    HANDLE_AZURE_REDIRECT,
} from '../../redux/login/types';

import { getToken, twoFAloginRequest } from './getToken';
import logout from './logout';
import { initAzureAuthSaga, loginWithAzure, handleAzureRedirect } from './initAzurAuthSaga';

export default function*() {
    yield all([
        takeLatest(LOGIN_REQUEST, getToken),
        takeLatest(LOGOUT_REQUEST, logout),
        takeLatest(TWO_FA_LOGIN_REQUEST, twoFAloginRequest),
        takeLatest(INIT_AZURE_AUTH, initAzureAuthSaga),
        takeLatest(LOGIN_VIA_AZURE, loginWithAzure),
        takeLatest(HANDLE_AZURE_REDIRECT, handleAzureRedirect),
    ]);
}
